import { useId } from 'react'
import { useT } from '../hooks'
import { DEFAULT_ZONE, zoneOptions } from '../report/timezone'

// Timezone the report's days are cut in: Paris unless the viewer picks another.
const BBookZoneSelect = ({ zone, setZone }) => {
  const { t } = useT()
  const id = useId()
  const label = (option) => (option === DEFAULT_ZONE ? t('pages.b_book.zone.paris') : option === 'UTC' ? 'UTC' : t('pages.b_book.zone.local', { zone: option }))

  return (
    <div className='b_book_zone_select'>
      <label htmlFor={id}>{t('pages.b_book.zone.label')}</label>
      <select id={id} value={zone} onChange={(e) => setZone(e.target.value)}>
        {zoneOptions().map((option) => <option key={option} value={option}>{label(option)}</option>)}
      </select>
    </div>
  )
}

export default BBookZoneSelect
